import instance from 'utils/apiCalls';
import { paramsI, ProductFormInterface } from '../../../types/interface';
import { PRODUCT_URLS } from './productUrls';
import { productSlice } from './productSlice';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'redux/store';
import { Action } from '@reduxjs/toolkit';

const { actions } = productSlice;
export const getAllProduct =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(PRODUCT_URLS.GET_ALL_PRODUCT, {
      params: params
    });

    dispatch(
      actions.setProductTotalPages({
        totalPages: response?.data?.meta?.totalPages,
        totalRecords: response?.data?.meta?.totalRecords
      })
    );

    return response;
  };

export const getAllProductNew =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(PRODUCT_URLS.GET_ALL_PRODUCT_NEW, {
      params: params
    });
    if (response?.data?.meta?.currentPage === 1) {
      dispatch(
        actions.setProductTotalPages({
          totalPages: response?.data?.meta?.totalPages,
          totalRecords: response?.data?.meta?.totalRecords
        })
      );
    }
    return response;
  };

export const getApplicationTypeOption = (params?: paramsI) => async () => {
  const response = await instance.get(
    `${PRODUCT_URLS.GET_ALL_PRODUCT_OPTION_TYPE}`,
    { params }
  );
  return response;
};

export const updateProduct =
  (id: number, data: ProductFormInterface) => async () => {
    const response = await instance.put(
      `${PRODUCT_URLS.UPDATE_PRODUCT}/${id}`,
      data
    );
    return response;
  };

export const createProduct = (data: ProductFormInterface) => async () => {
  const response = await instance.post(`${PRODUCT_URLS.UPDATE_PRODUCT}`, data);
  return response;
};

export const getSingleProduct = (id: number) => async () => {
  const response = await instance.get(`${PRODUCT_URLS.UPDATE_PRODUCT}/${id}`);
  return response;
};

export const deleteProduct = (id: number) => async () => {
  const response = await instance.delete(
    `${PRODUCT_URLS.UPDATE_PRODUCT}/${id}`
  );
  return response;
};
